module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n")
    ; 
var fontService = require('FontService').default;

var size = fontService.getFontSizes();
var fonts = fontService.getFonts();

var border = [1, 2, 3, 5, 7, 9];
var radius = [0, 2, 4, 6, 8, 10, 15, 20];
var checked = u.isTrue(groupBgTransparent) ? 'checked' : '';

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Groups</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Header Text</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"groupText\" name=\"groupTextColor\" type=\"color\" value=\"")
    ; __append(escapeFn( groupTextColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"groupTextColor\" name=\"groupTextColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( groupTextColor ))
    ; __append("\" />\r\n\r\n            <select name=\"groupFont\" class=\"style-font\"  id=\"groupFont\">\r\n               \r\n            </select>\r\n\r\n            <select name=\"groupFontSize\" id=\"groupFontSize\" class=\"style-font-size\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"groupTextBold\" class=\"weightSelectorGroup\" name=\"groupTextWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( groupTextWeightSelection ))
    ; __append("\" />\r\n            <img id=\"groupTextItalic\" class=\"styleSelectorGroup\" name=\"groupTextStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( groupTextStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\"  title=\"Header Background\">Header Background</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"groupTitle\" name=\"groupTitleBg\" type=\"color\" value=\"")
    ; __append(escapeFn( groupTitleBg ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"groupTitleBg\" name=\"groupTitleBg\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( groupTitleBg ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Border</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"groupBorder\" name=\"groupBorderColor\" type=\"color\" value=\"")
    ; __append(escapeFn( groupBorderColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"groupBorderColor\" name=\"groupBorderColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( groupBorderColor ))
    ; __append("\" />\r\n\r\n            <select name=\"groupBorderStyle\" class=\"style-font\"  id=\"groupBorderStyle\">\r\n                <option value=\"None\">None</option>\r\n                <option value=\"Solid\">Solid</option>\r\n            </select>\r\n\r\n            <select name=\"groupBorderSize\" id=\"groupBorderSize\" class=\"style-border-size\">\r\n                ")
    ;  for (var i = 0; i < border.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(border[i]))
    ; __append("\">")
    ; __append(escapeFn(border[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n\r\n            <select name=\"groupBorderRadius\" id=\"groupBorderRadius\" class=\"style-border-radius\">\r\n                ")
    ;  for (var i = 0; i < radius.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(radius[i]))
    ; __append("\">")
    ; __append(escapeFn(radius[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Background</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"groupBg\" name=\"groupBgColor\" type=\"color\" value=\"")
    ; __append(escapeFn( groupBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"groupBgColor\" name=\"groupBgColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( groupBgColor ))
    ; __append("\" />\r\n\r\n            <input type=\"checkbox\" name=\"groupBgTransparent\" ")
    ; __append(escapeFn( checked ))
    ; __append(" /> Transparent\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Picture</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <select name=\"groupBgImage\" style=\"width: 90%\" id=\"groupBgImage\">\r\n                <option value=\"None\">None</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}